import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MultilinePipe } from './multiline.pipe';
import { PercentagePipe } from './percentage.pipe';
import { BooleanPipe } from './boolean.pipe';
import { SignedNumberPipe } from './signed-number.pipe';
import { EscapeHtmlPipe } from './escape-html.pipe';
import { SafePipe } from './safe.pipe';

export const Pipes = [
  MultilinePipe,
  PercentagePipe,
  BooleanPipe,
  SignedNumberPipe,
  EscapeHtmlPipe,
  SafePipe,
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: Pipes,
  exports: Pipes
})
export class PipesModule { }
